import { Promise } from 'core-js';
import AuthService from '@/services/auth.service.js';

const state = {
    utente: null,
    azienda: null,
    carrello: null    
}

const getters =  {
    getUsername: (state) => {
        return state.utente.Username;
    },
    getAzienda: (state) => {
        return  state.azienda  ?? JSON.parse(localStorage.getItem("azienda"));
    },
    getAuthenticated(state){
        if(state.utente){
            return state.utente;
        }
        else if (localStorage.getItem("utente")){
            return JSON.parse(localStorage.getItem("utente"));
        }
        else{
            return "";
        }       
    },
    getToken(state){
        if(state.utente && state.utente.Token){
            return state.utente.Token;
        }
        else if(localStorage.getItem("utente")){
            return JSON.parse(localStorage.getItem("utente")).Token;
        }
        else {
            return null;
        }
        //return (state.utente && state.utente.Token) ? state.utente.Token : JSON.parse(localStorage.getItem("utente")).Token;
    },
    getLingua(state){       
        return state.utente ? state.utente?.Lingua : JSON.parse(localStorage.getItem("utente"))?.Lingua;
    },
    getNome(state){       
        return state.utente ? state.utente?.Nome : JSON.parse(localStorage.getItem("utente"))?.Nome;
    },
    getCognome(state){       
        return state.utente ? state.utente?.Cognome : JSON.parse(localStorage.getItem("utente"))?.Cognome;
    },
    getDestinazioni(state){
        return state.azienda ? state.azienda?.Destinazioni : JSON.parse(localStorage.getItem("azienda"))?.Destinazioni;
    },
    getAnagraficaAzienda(state){
        return state.azienda ? state.azienda?.Anagrafica : JSON.parse(localStorage.getItem("azienda"))?.Anagrafica;
    }

}

const mutations = {

    setUtente: (state, utente) =>{
        state.utente = utente;    
    },
    setAzienda: (state, azienda) => {
        state.azienda = azienda
    },
    setToken: (state, token) => {
        state.token = token
    },
    deleteUtente: (state) => {
        state.utente = null;
    },
    deleteAzienda: (state) => {
        state.azienda = null;
    },
    deleteCarrello: (state) => {
        state.carrello = null;
    },
    setLangUtente: (state,lingua) =>{
        if(state.utente == null){
            var utente = JSON.parse(localStorage.getItem("utente"));
            utente.Lingua = lingua;
            state.utente = utente;
        }else{
            state.utente.Lingua = lingua;
        }
        localStorage.setItem('utente', JSON.stringify(state.utente));
        
    },
    clearStorage: (state) =>{
        state.utente = null;
        localStorage.clear();
    }
}

const actions = {

    login: ({commit}, user) => {    
        return AuthService.login(user.username, user.password).then(
        (authData) => {  
                let utente = {
                    Nome:  authData.Nome,
                    Cognome: authData.Cognome,                   
                    Lingua : "EN",
                    Token: authData.Token
                }           
                commit('setUtente', utente )
                commit('setAzienda', authData.Azienda);               
                commit('updateCarrello', authData.Carrello);
                return Promise.resolve(authData);
            },
            error => {                      
                return Promise.reject(error);
            }
        );
    },
    SetLangUtente: ({commit},data) =>{
        commit('setLangUtente',data.data);
        return true;
    },
    ClearStorage:({commit}) =>{
        commit('clearStorage');
        return true;
    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}